import { Button, Space, Typography } from 'antd'
import { HelpMessage } from 'utils/constants'
import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { PayItemConnection } from '../../ConnectionsContext'
import { googleSheetFields } from './googleSheetFields'
import { useKeyedBooleans } from 'hooks/useKeyedBooleans'

export function useExpand(): ExpandOptions<PayItemConnection> {
  const help = HelpMessage.PayItems.Manage.Connections
  const [visible, { add, remove }] = useKeyedBooleans()
  return {
    render: ({
      id,
      lastAttemptedDate,
      lastSyncDate,
      lastSyncError,
      googleSheet,
    }) => {
      return {
        additionalInfo: [
          {
            type: 'date',
            date: lastAttemptedDate,
            label: 'Last Attempted Date',
            format: 'shortDatetime',
            help: help.LastAttemptedDate,
          },
          {
            type: 'date',
            date: lastSyncDate,
            label: 'Last Sync Date',
            format: 'shortDatetime',
            help: help.LastSyncDate,
          },
          {
            type: 'default',
            label: 'Last Sync Error',
            help: help.LastSyncError,
            children: !lastSyncError ? null : (
              <Space direction="vertical" size="small">
                <Space size="small">
                  <Typography.Text type="warning">
                    {lastSyncError.message}
                  </Typography.Text>
                  {lastSyncError.stack && (
                    <Button
                      onClick={() => (visible(id) ? remove(id) : add(id))}
                    >
                      {visible(id) ? 'Hide' : 'Show'} Details
                    </Button>
                  )}
                </Space>
                {visible(id) && (
                  <Space direction="vertical" size="small">
                    {lastSyncError.stack?.split('\n').map((message) => (
                      <Typography.Text>{message}</Typography.Text>
                    ))}
                  </Space>
                )}
              </Space>
            ),
          },
        ],
        custom: [googleSheetFields(googleSheet)],
      }
    },
  }
}
